import InputDate from "@/Components/Base/Input/InputDate";
import InputPreco from "@/Components/Base/Input/InputPreco";
import { TypeInscricaoDoAlunoNaViagem } from "@/Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import { IGerarLinkPagamentoInscricaoParams } from "@/Services/Domain/Viagem/InscricaoService";
import { Col, Form, FormProps, InputNumber, Row } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect } from "react";
import ProvedorPgtoSelect from "../../Financeiro/ProvedorPgto/ProvedorPgtoSelect";
export interface IGerarLinkPagamentoFormBasicProps extends FormProps<IGerarLinkPagamentoInscricaoParams> {
    inscricao : TypeInscricaoDoAlunoNaViagem;
}

export interface IGerarLinkPagamentoInscricaoParamsFormType extends IGerarLinkPagamentoInscricaoParams {
    codTitulo ?: number;
    dataPagamento ?: Dayjs;
}

export default function GerarLinkPagamentoFormBasic({
    inscricao,
    form: formParam,
    disabled,
    component,
    layout,
    autoComplete,
    ...rest
}:IGerarLinkPagamentoFormBasicProps) {
    let dataVencimentoInicial:Date|dayjs.Dayjs = (inscricao.titulo?.dataVencimento ?? (inscricao.viagem?.prazoDeInscricao ?? inscricao.viagem?.fim)) as Date|dayjs.Dayjs;
    if (typeof dataVencimentoInicial === "string")
        dataVencimentoInicial = dayjs(dataVencimentoInicial);
    
    const valorInicial : IGerarLinkPagamentoInscricaoParamsFormType|undefined = inscricao.titulo !== undefined ? {
        codTitulo : inscricao?.titulo?.codigo ?? undefined,
        codInscricao : inscricao.codigo,
        dataVencimento : dataVencimentoInicial,
        dataPagamento : inscricao.titulo.dataPagamento ? dayjs(inscricao.titulo.dataPagamento) as Dayjs : undefined,
        quantidadeParcelas : inscricao.titulo.parcelas,
        valorBase : inscricao.titulo.valorPrevisto,
        codProvedorConciliacao : inscricao.codProvedorPagamento ?? undefined
    } as IGerarLinkPagamentoInscricaoParamsFormType : undefined;

    useEffect(() => {
        formParam?.resetFields();
    }, [inscricao]);

    return <Form
        {...rest}
        form={formParam}
        disabled={disabled}
        component={component ?? "div"}
        layout={layout ?? "vertical"}
        autoComplete={autoComplete ?? "off"}
        initialValues={valorInicial}
    >
        <Row gutter={8} wrap>
            <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                name={"codInscricao"}
                label={"Código da Inscrição"}
                initialValue={(inscricao.codigo as number)}
                rules={[{ required: true, message: "Por favor, informe a inscrição" }]}
                hidden
            />
            
            <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                name={"codTitulo"}
                label={"Código título"}
                initialValue={(inscricao?.titulo?.codigo ?? undefined) as number|undefined}
                hidden
            />

            <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                name={"enviaEmail"}
                label={"Envia e-mail?"}
                initialValue={false}
                rules={[{ required: true, message: "Por favor, se deve enviar um e-mail de cobrança" }]}
                hidden
            />

            <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                    name={"dataVencimento"}
                    label={"Data vencimento"}
                    rules={[{ required: true, message: "Por favor, informe a data de vencimento" }]}
                >
                    <InputDate />
                </Form.Item>
            </Col>  

            {inscricao.titulo?.dataPagamento && <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                    name={"dataPagamento"}
                    label={"Data pagamento"}
                >
                    <InputDate disabled />
                </Form.Item>
            </Col>}

            <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                    name={"quantidadeParcelas"}
                    label={"Qtd. max. parcelas"}
                    rules={[{ required: true, message: "Por favor, informe a quantidade de parcelas" }]}
                    initialValue={1}
                >
                    <InputNumber />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                    name={"valorBase"}
                    label={"Valor total"}
                    rules={[{ required: true, message: "Por favor, informe o valor do pagamento" }]}
                >
                    <InputPreco />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item<IGerarLinkPagamentoInscricaoParamsFormType>
                    name={"codProvedorConciliacao"}
                    label={"Provedor Pgto."}
                >
                    <ProvedorPgtoSelect placeholder={"Padrão"} />
                </Form.Item>
            </Col>
        </Row>
    </Form>
}